
import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const BoardMembersEditor = () => {
  const columns = [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'role', label: 'Role', type: 'text' },
    { key: 'position', label: 'Position', type: 'text' },
    { key: 'image', label: 'Image URL', type: 'image' },
  ];

  return <GenericTableEditor tableName="board_members" columns={columns} title="Board Members Manager" reorderable={true} />;
};

export default BoardMembersEditor;
